//ENVIRONMENT VARIABLE
const apiUrl = process.env.REACT_APP_BASE_URL;

// VARIABLES
export const refresh_time = process.env.REACT_APP_TIME_OUT;

// HTTP fallback poll while websockets are primary.
// Set REACT_APP_ORDER_POLL_FALLBACK=false to disable get-order polling entirely.
const pollFlag = String(process.env.REACT_APP_ORDER_POLL_FALLBACK ?? "true")
  .trim()
  .toLowerCase();
export const order_poll_fallback_enabled =
  pollFlag !== "false" && pollFlag !== "0" && pollFlag !== "off";

// APIES URLS
export const get_rooms_url = apiUrl + "get-rooms";
export const get_all_orders = apiUrl + "get-order";
export const update_orders_status = apiUrl + "update-order-status/";
export const update_room_status = apiUrl + "update-room-status/";
export const update_order_prepare = apiUrl + "update-order-prepare/";
export const login_user = apiUrl + "login";
export const getMenus = apiUrl + "get-grouped-menus";
export const saveRoomsOrders = apiUrl + "save-room-orders";
export const get_floors = apiUrl + "get-floors";
export const check_in_room = apiUrl + "check-in-room";
export const get_exist_customers = apiUrl + "get_exist_customers";
export const room_checkout_detail = apiUrl + "room-check-out-detail";
export const room_check_out = apiUrl + "room-check-out";
export const get_sessions = apiUrl + "get-all-sessions";
export const getCustomers = apiUrl + "get-customers";
export const viewReport = apiUrl + "view-report";
export const changePassword = apiUrl + "change-password";
export const getDeliverOrder = apiUrl + "get_deliver_orders/";
